import styled from 'styled-components';
import colors from 'Styles/colors';

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
SectionHeader.displayName = 'SectionHeader';

export const HeaderTitles = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & .user_new_badge {
    min-width: unset;
  }
`;
HeaderTitles.displayName = 'HeaderTitles';

export const Chevron = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${colors.blueCerulean};
  font-size: 12px;
`;
Chevron.displayName = 'Chevron';

export const CollapsePanel = styled.div`
  overflow: hidden;
  max-height: ${({ $expanded, $height }) => ($expanded ? `${$height}px` : '0')};
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0)};
  margin-top: ${({ $expanded }) => ($expanded ? '12px' : '0')};
  transition: max-height 0.25s ease, opacity 0.2s ease, margin-top 0.25s ease;
`;
CollapsePanel.displayName = 'CollapsePanel';

export const Panel = styled.div`
  padding: 14px 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.borders.reportsBox};
  margin-bottom: 3px;
`;
Panel.displayName = 'Panel';

export const StepsList = styled.ol`
  margin: 12px 0 0;
  padding-left: 18px;
  font-size: 13.5px;
  color: ${({ theme }) => theme.text.modalDescription};

  li {
    margin-bottom: 4px;
  }
`;
StepsList.displayName = 'StepsList';
